<template>
  <div>
    <div id="firebaseui-auth-container" />
    <b-field label="メールアドレス">
      <b-input ref="email" type="email" v-model="email" required />
    </b-field>
    <b-field label="パスワード">
      <b-input
        ref="password"
        type="password"
        v-model="password"
        required
        minlength="8"
        maxlength="100"
        :pattern="passwordRegEx"
        validation-message="半角英数字をそれぞれ1種類以上含む8文字以上100文字以下のパスワードにしてください"
        password-reveal
      />
    </b-field>
    <b-field
      label="パスワード(確認)"
      :type="password === passwordConfirm ? '' : 'is-danger'"
      :message="
        password === passwordConfirm ? '' : 'パスワードの確認ができていない'
      "
    >
      <b-input ref="passwordConfirm" type="password" v-model="passwordConfirm" password-reveal />
    </b-field>
  </div>
</template>

<script>
import * as authServices from '@/services/authServices';

export default {
  name: 'EmailRegistrationForm',
  props: ['value'],
  data() {
    return {
      passwordConfirm: '',
      passwordRegEx: '(?=.*?[a-zA-Z])(?=.*?\\d)[a-zA-Z\\d]{8,100}'
    };
  },
  computed: {
    email: {
      get() {
        return this.value.email;
      },
      set(email) {
        this.updateValue({ email });
      }
    },
    password: {
      get() {
        return this.value.password;
      },
      set(password) {
        this.updateValue({ password });
      }
    },
    // calculate and notify parent of new property
    isValid() {
      return this.email != '' &&
            this.password != '' &&
            this.passwordConfirm != '' &&
            this.$refs.email.isValid &&
            this.$refs.password.isValid &&
            this.$refs.passwordConfirm.isValid &&
            this.$_validateEmail() && this.$_validatePassword()
    }
  },
  watch: {
    isValid: {
      handler(isValid) {
        this.updateValue({ isValid });
      },
      immediate: true
    }
  },
  methods: {
    async $_validateEmail() {
      let atposition = this.email.indexOf('@');
      let dotposition = this.email.lastIndexOf('.');
      if (
        atposition < 1 ||
        dotposition < atposition + 2 ||
        dotposition + 2 >= this.email.length
      ) {
        return false;
      }
      await authServices.checkEmailDuplicated(this.email.trim());
      return true;
    },
    $_validatePassword() {
      return (
        // passwordとpassword確認が一致しているかどうか
        this.password == this.passwordConfirm &&
        // passwordが規定のパターンに沿っているかどうか
        Boolean(this.password.match(new RegExp(this.passwordRegEx)))
      );
    },
    updateValue(diff) {
      let newValue = { ...this.value, ...diff };
      this.$emit('input', newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/signup-email.scss';
</style>
